import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
import subtleAlgorithm from './subtle_dsa.js';
import crypto from './webcrypto.js';
import checkKeyLength from './check_key_length.js';
import getVerifyKey from './get_sign_verify_key.js';
var verify = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(alg, key, signature, data) {
    var cryptoKey, algorithm;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getVerifyKey(alg, key, 'verify');
          case 2:
            cryptoKey = _context.sent;
            checkKeyLength(alg, cryptoKey);
            algorithm = subtleAlgorithm(alg, cryptoKey.algorithm);
            _context.prev = 5;
            _context.next = 8;
            return crypto.subtle.verify(algorithm, cryptoKey, signature, data);
          case 8:
            return _context.abrupt("return", _context.sent);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", false);
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11]]);
  }));
  return function verify(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export default verify;